var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.797 105.035C172.335 111.737 176.263 120.417 175.631 129.893C174.093 152.362 175.247 173.87 168.379 195.762C164.231 209.029 158.599 226.334 144.533 231.745C136.099 234.987 126.676 234.629 117.748 233.256C105.578 231.361 85.9631 227.845 77.3369 218.451C70.4689 211.007 67.7767 200.322 67.1723 190.543C65.7437 167.415 73.4359 143.847 81.4852 122.477C83.7928 116.351 86.2378 110.281 88.7652 104.265C94.809 95.8602 105.798 86.3012 116.429 85.3124C149.698 81.5218 159.863 99.3761 165.797 105.035Z",
    fill: "url(#paint0_radial_336_53305)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.83 50.8118C174.204 50.647 170.605 50.7843 167.061 52.0753C167.061 51.4435 166.979 50.9216 167.089 50.4547C167.721 47.5705 168.078 44.549 169.094 41.8022C172.501 32.4356 176.182 23.1788 179.698 13.867C180.001 13.0705 179.918 12.1366 180.001 11.2576C179.094 11.285 178.077 11.0928 177.253 11.4224C173.847 12.8233 170.385 14.1143 167.254 16.1469C163.462 18.5916 159.369 20.5693 156.1 23.7831C153.16 26.6398 149.699 28.9746 147.886 32.875C147.529 33.6441 146.512 34.0836 145.798 34.7154C145.551 34.4133 145.441 34.3309 145.386 34.221C145.056 33.2321 144.699 32.2158 144.452 31.1995C142.639 23.5359 140.523 15.9821 136.787 8.97771C136.43 8.29101 135.963 7.65924 135.551 7C135.414 7.02747 135.276 7.05494 135.139 7.0824C134.947 7.54936 134.699 8.01632 134.617 8.53822C134.342 9.9391 134.15 11.34 133.903 12.7409C132.117 23.7831 128.93 34.4682 126.018 45.2357C125.853 45.8675 125.496 46.4169 125.057 47.4057C123.958 45.1808 123.024 43.3679 122.172 41.5275C120.496 37.9292 118.738 34.3583 115.496 31.9411C112.145 29.469 108.601 27.299 105.14 24.9917C104.975 24.8818 104.727 24.9367 104.123 24.8543C104.48 25.8981 104.672 26.7496 105.03 27.5462C109.645 37.3524 112.942 47.5156 113.051 58.5029C112.969 58.5578 112.914 58.6127 112.914 58.7226C112.969 59.0248 113.106 59.3269 113.106 59.6291C112.969 63.0901 112.887 66.5785 112.667 70.0395C112.529 72.0996 112.749 72.7039 114.507 73.061C129.04 76.1375 143.573 79.159 158.105 82.2629C159.397 82.5375 160.083 82.1255 160.633 81.0543C161.1 80.1478 161.732 79.3238 162.281 78.4448C162.226 78.3074 162.171 78.1701 162.116 78.0327C166.787 68.3914 173.572 60.0686 179.753 51.0315C178.792 50.8942 178.325 50.8392 177.83 50.8118Z",
    fill: "url(#paint1_radial_336_53305)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M165.797 105.035C164.176 103.497 162.253 101.079 159.643 98.415C159.781 99.8983 159.781 101.409 159.671 102.947C158.132 125.416 159.286 146.924 152.418 168.816C148.27 182.083 142.638 199.388 128.572 204.799C120.139 208.041 110.716 207.683 101.787 206.31C92.0897 204.799 77.6395 202.245 67.832 196.531C69.0408 204.497 71.8704 212.49 77.3098 218.424C85.936 227.79 105.551 231.334 117.721 233.229C126.677 234.63 136.072 234.987 144.506 231.718C158.599 226.307 164.204 209.002 168.352 195.735C175.22 173.843 174.066 152.335 175.604 129.866C176.264 120.39 172.335 111.71 165.797 105.035Z",
    fill: "url(#paint2_radial_336_53305)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.986 59.4658C114.041 59.7679 114.179 60.0701 114.179 60.3722C114.041 63.7233 113.959 67.047 113.739 70.3707C121.294 57.6803 133.217 44.99 146.101 33.8654C145.881 33.2336 145.689 32.6019 145.551 31.9426C143.738 24.279 141.623 16.7253 137.887 9.72087C137.53 9.03417 137.063 8.4024 136.651 7.74316C136.513 7.77063 136.376 7.7981 136.238 7.82557C136.046 8.29253 135.799 8.75949 135.716 9.28138C135.442 10.6823 135.249 12.0831 135.002 13.484C133.217 24.5262 130.03 35.2114 127.118 45.9789C126.953 46.6107 126.596 47.16 126.156 48.1489C125.057 45.924 124.123 44.1111 123.272 42.2707C121.596 38.6724 119.838 35.1015 116.596 32.6843C113.244 30.2121 109.701 28.0422 106.239 25.7348C106.074 25.625 105.827 25.6799 105.223 25.5975C105.58 26.6413 105.772 27.4928 106.129 28.2894C110.745 38.0955 114.041 48.2588 114.151 59.246C114.014 59.301 113.959 59.3559 113.986 59.4658Z",
    fill: "url(#paint3_radial_336_53305)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.598 94.9796C148.598 100.83 136.675 95.2543 126.895 95.2543C117.115 95.2543 104.094 99.457 104.094 93.6062C104.094 87.7555 116.978 84.8164 126.758 84.8164C136.538 84.8164 148.598 89.1289 148.598 94.9796Z",
    fill: "url(#paint4_radial_336_53305)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M156.127 128.765C152.308 124.398 147.199 119.371 140.55 114.152C156.292 115.828 170.028 120.799 170.028 120.799C170.028 120.799 157.665 112.284 133.215 109.263C133.133 109.263 133.078 109.235 132.996 109.235C115.194 99.6765 95.9084 102.039 95.9084 102.039C95.9084 102.039 103.655 103.412 119.891 109.318C114.397 110.005 109.37 111.46 105.029 113.108C94.7271 111.323 86.8701 112.284 86.8701 112.284C86.8701 112.284 90.9085 112.999 99.26 115.635C92.6667 118.794 88.7108 121.898 88.7108 121.898C88.7108 121.898 93.6832 120.003 104.864 117.476C108.491 118.712 112.721 120.223 117.501 122.091C117.941 122.255 118.38 122.448 118.82 122.64C100.084 124.563 86.2383 135.385 86.2383 135.385C86.2383 135.385 95.5787 131.814 117.556 127.969C120.771 127.419 124.122 127.145 127.474 127.117C143.957 137.116 157.088 153.322 157.088 153.322C157.088 153.322 151.676 141.373 135.083 127.392C141.979 127.914 148.627 129.15 154.094 130.441C161.401 137.253 166.127 143.076 166.127 143.076C166.127 143.076 164.011 138.434 158.407 131.54C163.984 133.023 167.528 134.314 167.528 134.314C167.528 134.314 163.709 131.622 156.127 128.765ZM130.743 122.722C130.138 122.64 129.534 122.585 128.93 122.53C124.232 119.316 119.314 117.064 114.534 115.471C116.265 115.141 118.106 114.811 120.029 114.454C123.463 113.85 127.062 113.603 130.66 113.575C137.693 116.954 144.369 121.843 149.973 126.65C144.699 125.112 138.298 123.656 130.743 122.722Z",
    fill: "url(#paint5_radial_336_53305)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.554 198.482C156.812 202.685 154.312 205.761 151.977 205.322C149.642 204.91 148.379 201.174 149.12 196.971C149.862 192.769 152.362 189.692 154.697 190.132C157.032 190.516 158.296 194.279 157.554 198.482Z",
    fill: "url(#paint6_radial_336_53305)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.771 191.889C120.029 196.092 117.529 199.168 115.194 198.729C112.859 198.317 111.595 194.581 112.337 190.378C113.079 186.176 115.579 183.099 117.914 183.539C120.249 183.923 121.513 187.687 120.771 191.889Z",
    fill: "url(#paint7_radial_336_53305)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.942 200.101C133.051 200.266 133.299 200.293 133.436 200.156C133.711 199.936 133.985 199.716 134.233 199.469C134.425 199.249 134.507 198.947 134.727 198.727C135.112 198.315 135.634 198.178 136.046 198.563C136.321 198.81 136.458 199.332 136.458 199.716C136.43 200.073 136.156 200.431 135.963 200.788C135.029 202.353 133.354 203.04 132.062 202.408C130.771 201.776 130.03 199.716 130.606 198.233C130.744 197.876 131.156 197.464 131.513 197.409C132.117 197.327 132.31 197.849 132.392 198.37C132.584 199.469 132.612 199.634 132.942 200.101Z",
    fill: "#3E335D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_336_53305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.869 239.561) scale(220.266 220.236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2377,
    stopColor: "#FBB906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4868,
    stopColor: "#FCC42B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#FDD869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEDB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEDE79"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_336_53305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.627 100.912) scale(247.353 247.319)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#74CA69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#77CB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90D488"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_336_53305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.079 92.1695) scale(180.499 180.474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA347",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8444,
    stopColor: "#D97816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D96416"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_336_53305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.307 85.8825) scale(166.343 166.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#3AB72B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BC24E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_336_53305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.418 51.1157) scale(90.1626 90.1504)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEA347",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_336_53305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.816 -33.4676) scale(361.747 361.697)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA347",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97816"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_336_53305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.329 197.72) rotate(10.1646) scale(6.24629 6.24549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#76203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661A39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_336_53305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.556 191.126) rotate(10.1646) scale(6.2463 6.24548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#76203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661A39"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading10);
export default __webpack_public_path__ + "static/media/loading_10.9f530d352030fb1ca85a21cfa81b2d9b.svg";
export { ForwardRef as ReactComponent };